"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var vehicleOptionsTaxesStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        element: {
            borderBottom: "1px solid " + palette.primaryDisabled.main,
            padding: '5px 0',
            '& span, div': {
                fontFamily: typography.fontFamily2,
            },
            maxHeight: '40px',
        },
    });
}, { name: 'GqlSummary_AdditionalCarDetailsTaxes' });
exports.default = vehicleOptionsTaxesStyles;
